/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as settingsSlice from './settingsSlice';

export default function* watchSettingsSaga() {
 yield takeLatest(settingsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(settingsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(settingsSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(settingsSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(settingsSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  settingsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  settingsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  settingsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  settingsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  settingsSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
